import { render, staticRenderFns } from "./EditOrderItemDialog.vue?vue&type=template&id=3388b112"
import script from "./EditOrderItemDialog.vue?vue&type=script&lang=js"
export * from "./EditOrderItemDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports